const VALID_ADDITIONAL_COVERAGE_TYPES = new Set([
  'ReplacementCost',
  'FraudProtection',
  'WaterSewerBackup',
])

interface UseRentersStepThreePageProps {
  additionalCoverageTypes: string[]
}

export function useRentersStepThreePage({
  additionalCoverageTypes,
}: UseRentersStepThreePageProps) {
  const validAdditionalCoverageTypes = additionalCoverageTypes.filter((t) =>
    VALID_ADDITIONAL_COVERAGE_TYPES.has(t),
  )
  const hasAdditionalCoverage = validAdditionalCoverageTypes.length > 0

  return { validAdditionalCoverageTypes, hasAdditionalCoverage }
}
